const TIMEZONE_SUFFIX = /Z$|[+-]\d{2}:?\d{2}$/;

export const parseUtcDate = (timestamp) => {
  if (!timestamp) return null;
  return new Date(TIMEZONE_SUFFIX.test(timestamp) ? timestamp : `${timestamp}Z`);
};
